export interface ITipoMovimientoBeca {
  id?: string | null;
  clave?: string | null;
  descripcion?: string | null;
  activo?: boolean | null;
}

export class TipoMovimientoBeca implements ITipoMovimientoBeca {
  constructor(
    public id?: string | null,
    public clave?: string | null,
    public descripcion?: string | null,
    public activo?: boolean | null
  ) {}

  static fromObject(data: ITipoMovimientoBeca): TipoMovimientoBeca {
    const tipoMovimientoBeca = new TipoMovimientoBeca();
    for (const [key, value] of Object.entries(data)) {
      tipoMovimientoBeca[key] = value;
    }
    return tipoMovimientoBeca;
  }
}
